import React from 'react';
import Grid from '@material-ui/core/Grid';

import { useGraphqlQuery } from '../../../hooks/api';
import { GET_DEMO_COURSE, CourseGraphQL } from '../../../api/content';
import LoadingPage from '../../../common/components/LoadingPage';
import CourseDetail from '../../../common/components/CourseDetail';
import SignupCTA from './SignupCTA';

export default function DemoPage() {
  const { isLoading, data: { course: demo } = {} } = useGraphqlQuery<{
    course: CourseGraphQL;
  }>(
    { document: GET_DEMO_COURSE },
    {
      queryKey: ['course', 'demo'],
      errorMessage:
        "We're having trouble loading the Picardy demo at the moment.",
    },
  );

  if (isLoading || !demo) return <LoadingPage />;
  return (
    <Grid item xl={8} lg={9} md={10} xs={12} style={{ margin: '1em' }}>
      <SignupCTA />
      <CourseDetail course={demo} hideEducatorFeatures />
    </Grid>
  );
}
